<template>
  <v-container class="px-3">
    <div class="mb-4">
      <h1>Baixa de pagamento</h1>
      <div>Realize a associação de lotes de faturamento com o pagamento.</div>
    </div>
    <informacoes-pagamento
      v-if="getPagamento"
      :pagamento="getPagamento"
      :show-valor-pendente="true"
      class="mb-2"
    />
    <v-tabs>
      <v-tab>
        <h3>Lotes de faturamento</h3>
      </v-tab>
      <v-tab-item>
        <div class="d-flex">
          <pagamento-baixa-faturamento-lotes-status-bar
            v-if="getFaturamentoLotesPage"
            :selectedFaturamentoLotes="selectedFaturamentoLotes"
            :totalFaturamentoLotes="totalFaturamentoLotes"
            :loadingBaixaLotes="loadingBaixaLotes"
            :loadingDesfazerBaixaLotes="loadingDesfazerBaixaLotes"
            :statusCount="statusCount"
            :disableValorPendente="disableValorPendente"
            :disablePagamentoPublicado="disablePagamentoPublicado"
            @action:baixa-lotes="handleRealizarBaixa"
            @action:desfazer-baixa-lotes="handleDesfazerBaixaLotes"
            @change:select-all="handleFaturamentoSelectAll"
            @change:deselect-all="handleFaturamentoDeselectAll"
          />
          <filtro-faturamento-lote
            :minDataFaturamentoCronograma.sync="minDataFaturamentoCronograma"
            :maxDataFaturamentoCronograma.sync="maxDataFaturamentoCronograma"
            :valorPendenteOnly.sync="valorPendenteOnly"
            :filterNumeroLote.sync="filterNumeroLote"
            :valorPendenteLte.sync="valorPendenteLte"
            :valorPendentePagamento="valorPendentePagamento"
            :page.sync="faturamentoPage"
            @clearFilters="handleClearFilters"
          />
        </div>

        <v-progress-linear v-if="$asyncComputed.getFaturamentoLotesPage.updating" />
        <template v-else>
          <pagamento-baixa-faturamento-lotes-list
            v-if="getFaturamentoLotesPage"
            :faturamentoLotes="faturamentoLotes"
            :selectedFaturamentoLotes="selectedFaturamentoLotes"
            :conciliacaoLotes="conciliacaoLotes"
            @click:checkbox="handleFaturamentoCheckboxClick"
          />
          <v-pagination
            v-if="hasFaturamentoPagination"
            v-model="faturamentoPage"
            :length="faturamentoPaginationLength"
          />
        </template>
      </v-tab-item>
      <v-tab>
        <h3>Lotes de faturamento Baixados</h3>
      </v-tab>
      <v-tab-item>
        <div class="d-flex">
          <pagamento-baixa-faturamento-lotes-baixados-status-bar
            v-if="getConciliacaoLotesPage"
            :selectedConciliacaoLotes="selectedConciliacaoLotes"
            :totalConciliacaoLotes="totalConciliacaoLotes"
            :loadingBaixaLotes="loadingBaixaLotes"
            :loadingDesfazerBaixaLotes="loadingDesfazerBaixaLotes"
            :disableValorPendente="disableValorPendente"
            :disablePagamentoPublicado="disablePagamentoPublicado"
            :statusCount="statusCount"
            @action:desfazer-baixa-lotes="handleDesfazerBaixaLotes"
            @change:select-all="handleConciliacaoSelectAll"
            @change:deselect-all="handleConciliacaoDeselectAll"
          />
        </div>

        <v-progress-linear v-if="$asyncComputed.getConciliacaoLotesPage.updating" />
        <template v-else>
          <pagamento-baixa-faturamento-lotes-baixados-list
            v-if="getConciliacaoLotesPage"
            :conciliacaoLotes="conciliacaoLotes"
            :selectedConciliacaoLotes="selectedConciliacaoLotes"
            @click:checkbox="handleConciliacaoCheckboxClick"
          />
          <v-pagination
            v-if="hasConciliacaoPagination"
            v-model="conciliacaoPage"
            :length="conciliacaoPaginationLength"
          />
        </template>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { conciliacaoClient } from '../../libs/conciliacao-client'
import InformacoesPagamento from './pagamento/InformacoesPagamento'
import PagamentoBaixaFaturamentoLotesList from './pagamento_baixa/PagamentoBaixaFaturamentoLotesList.vue'
import PagamentoBaixaFaturamentoLotesBaixadosList from './pagamento_baixa/PagamentoBaixaFaturamentoLotesBaixadosList.vue'
import PagamentoBaixaFaturamentoLotesBaixadosStatusBar from './pagamento_baixa/PagamentoBaixaFaturamentoLotesBaixadosStatusBar.vue'
import PagamentoBaixaFaturamentoLotesStatusBar from './pagamento_baixa/PagamentoBaixaFaturamentoLotesStatusBar.vue'
import FiltroFaturamentoLote from './pagamento_baixa/FiltroFaturamentoLote.vue'
import { formatCurrency } from '../../libs'
import { pagamentoLoteStatusLabels } from '../../libs/pagamento-lote-status-labels'

export default {
  components: {
    InformacoesPagamento,
    PagamentoBaixaFaturamentoLotesList,
    PagamentoBaixaFaturamentoLotesBaixadosList,
    PagamentoBaixaFaturamentoLotesStatusBar,
    PagamentoBaixaFaturamentoLotesBaixadosStatusBar,
    FiltroFaturamentoLote
  },
  props: {
    pagamentoId: { type: String, required: true },
  },
  data () {
    return {
      pagamentoLoteStatusLabels,
      selectedFaturamentoLotes: [],
      selectedConciliacaoLotes: [],
      loadingBaixaLotes: false,
      loadingDesfazerBaixaLotes: false,
      baixaPagamentoLoading: false,
      faturamentoPage: 1,
      faturamentoPageSize: 10,
      conciliacaoPage: 1,
      conciliacaoPageSize: 10,
      minDataFaturamentoCronograma: '',
      maxDataFaturamentoCronograma: '',
      valorPendenteOnly: true,
      filterNumeroLote: '',
      valorPendenteLte: null,
      statusCount: {}
    }
  },
  computed: {
    faturamentoLotes () {
      return this.getFaturamentoLotesPage?.data || []
    },
    totalFaturamentoLotes () {
      return this.getFaturamentoLotesPage?.totalSize || 0
    },
    totalConciliacaoLotes () {
      return this.getConciliacaoLotesPage?.totalSize || 0
    },
    faturamentoPaginationLength () {
      return Math.ceil(this.getFaturamentoLotesPage?.totalSize / this.faturamentoPageSize) || 0
    },
    hasFaturamentoPagination () {
      return this.getFaturamentoLotesPage?.totalSize / this.faturamentoPageSize > 1
    },
    hasConciliacaoPagination () {
      return this.getConciliacaoLotesPage?.totalSize / this.conciliacaoPageSize > 1
    },
    conciliacaoPaginationLength () {
      return Math.ceil(this.getConciliacaoLotesPage?.totalSize / this.conciliacaoPageSize) || 0
    },
    conciliacaoLotes () {
      return this.getConciliacaoLotesPage?.data || []
    },
    faturamentoLoteIdsAssociados () {
      return new Map(
        this.getConciliacaoLotesPage?.data.map(conciliacaoLote => [
          conciliacaoLote.faturamentoLoteId,
          conciliacaoLote.id
        ])
      )
    },
    somaValoresPendentes () {
      const faturamentoLotesIds = this.selectedFaturamentoLotes?.map(conciliacaoLote => conciliacaoLote.id)
      const faturamentoLotesInConciliacao = this.getFaturamentoLotesPage?.data.filter(faturamentoLote => faturamentoLotesIds.includes(faturamentoLote.id)) || []
      const valoresPendentes = faturamentoLotesInConciliacao.map(faturamentoLote => faturamentoLote.valorTotal - faturamentoLote.valorPagoConciliacaoItens)
      const somaValoresPendentes = valoresPendentes.reduce((sum, el) => sum + el, 0)
      return  somaValoresPendentes
    },
    valorPendentePagamento () {
      return this.getPagamento?.valorPago - this.getPagamento?.valorPagoConciliado || null
    },
    disableValorPendente () {
      return this.somaValoresPendentes > this.valorPendentePagamento
    },
    disablePagamentoPublicado () {
      return this.getPagamento.status === 'publicado'
    }
  },
  methods: {
    handleFaturamentoCheckboxClick (faturamentoLote, checked) {
      if (checked) {
        this.selectedFaturamentoLotes = this.selectedFaturamentoLotes.filter(lote => lote.id !== faturamentoLote.id)
      } else {
        this.selectedFaturamentoLotes.push(faturamentoLote)
      }
    },
    handleFaturamentoSelectAll () {
      this.selectedFaturamentoLotes = [...this.getFaturamentoLotesPage?.data]
    },
    handleFaturamentoDeselectAll () {
      this.selectedFaturamentoLotes = []
    },
    handleConciliacaoCheckboxClick (faturamentoLote, checked) {
      if (checked) {
        this.selectedConciliacaoLotes = this.selectedConciliacaoLotes.filter(lote => lote.id !== faturamentoLote.id)
      } else {
        this.selectedConciliacaoLotes.push(faturamentoLote)
      }
    },
    handleConciliacaoSelectAll () {
      this.selectedConciliacaoLotes = [...this.getConciliacaoLotesPage?.data]
    },
    handleConciliacaoDeselectAll () {
      this.selectedConciliacaoLotes = []
    },
    async handleBaixaLotes () {
      try {
        this.loadingBaixaLotes = true

        const command = {
          faturamentoLoteIds: this.selectedFaturamentoLotes.map(lote => lote.id)
        }

        await conciliacaoClient.pagamento.baixaCronograma(this.$props.pagamentoId, command)

        this.$asyncComputed.getFaturamentoLotesPage.update()
        this.$asyncComputed.getConciliacaoLotesPage.update()
        this.selectedFaturamentoLotes = []
        window.alert('Baixa realizada')
      } catch {
        window.alert('Erro ao realizar baixa')
      } finally {
        this.loadingBaixaLotes = false
      }
    },
    async handleDesfazerBaixaLotes () {
      try {
        this.loadingDesfazerBaixaLotes = true

        const faturamentoLotesIds = this.selectedFaturamentoLotes.length > 0 ? this.selectedFaturamentoLotes.map(lote => lote.id) : null
        const conciliacaoLotesIds = this.selectedConciliacaoLotes.length > 0 ? this.selectedConciliacaoLotes.map(lote => lote.faturamentoLoteId) : null

        const command = {
          faturamentoLoteIds: conciliacaoLotesIds || faturamentoLotesIds
        }
        await conciliacaoClient.pagamento.desfazerBaixa(this.$props.pagamentoId, command)

        this.$asyncComputed.getFaturamentoLotesPage.update()
        this.$asyncComputed.getConciliacaoLotesPage.update()
        this.selectedFaturamentoLotes = []
        this.selectedConciliacaoLotes = []
        window.alert('Baixa de lotes desfeita')
      } catch {
        window.alert('Erro ao desfazer baixa de lotes')
      } finally {
        this.loadingDesfazerBaixaLotes = false
      }
    },
    handleClearFilters () {
      this.minDataFaturamentoCronograma = ''
      this.maxDataFaturamentoCronograma = ''
      this.filterNumeroLote = ''
      this.valorPendenteLte = null
      this.faturamentoPage = 1
    },
    openModal () {
      const paramModal = {
        type: 'warning',
        title: 'Deseja realizar baixa?',
        message: `Valor pendente do pagamento (${formatCurrency(this.getPagamento.valorPago - this.getPagamento.valorPagoConciliado)}) não confere com o valor pendente nos Lotes de faturamento! (${formatCurrency(this.somaValoresPendentes)}).<br/> Valor da diferença: ${formatCurrency((this.getPagamento.valorPago - this.getPagamento.valorPagoConciliado) - this.somaValoresPendentes)}`,
        callback: this.handleBaixaLotes,
        btCancel: {
          name: 'Cancelar',
          show: true
        },
        btConfirm: {
          name: 'Confirmar baixa',
          show: true,
          color: 'primary'
        }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
    },
    handleRealizarBaixa () {
      if (this.valorPendentePagamento > this.somaValoresPendentes) {
        this.openModal()
      } else {
        this.handleBaixaLotes()
      }
    }
  },
  asyncComputed: {
    getFaturamentoLotesPage: {
      get () {
        const params = {
          prestadorPagamentoId: this.pagamentoId,
          operadoraAnsPagamentoId: this.pagamentoId,
          pageNumber: this.faturamentoPage - 1,
          pageSize: this.faturamentoPageSize,
          includeCronograma: true,
          minDataFaturamentoCronograma: this.minDataFaturamentoCronograma,
          maxDataFaturamentoCronograma: this.maxDataFaturamentoCronograma,
          valorPendenteOnly: this.valorPendenteOnly,
          numeroLote: this.filterNumeroLote,
          valorPendenteLte: this.valorPendenteLte || this.valorPendentePagamento
        }

        return conciliacaoClient.faturamentoLote.getFaturamentoLotesPage(params)
      }
    },
    getPagamento: {
      get () {
        const params = {
          includePrestador: true,
          includeOperadoraAns: true
        }

        return conciliacaoClient.pagamento.getPagamentoById(this.pagamentoId, params)
      }
    },
    getConciliacaoLotesPage: {
      get () {
        const params = {
          pagamentoId: this.$props.pagamentoId,
          includeFaturamentoLote: true,
          pageNumber: this.conciliacaoPage - 1,
          pageSize: this.conciliacaoPageSize,
        }

        return conciliacaoClient.conciliacaoLote.getConciliacaoLotesPage(params)
      }
    }
  },
  async mounted () {
    const result = await conciliacaoClient.pagamentoLote.getPagamentoLotesStatusesCount({ pagamentoId: this.pagamentoId })

    this.statusCount = result.data.reduce((statuses, data) => {
      statuses[data.status] = data.count

      return statuses
    }, {})
  },
  filters:{
    formatCurrency (value) {
      return this.formatCurrency(value)
    }
  }
}
</script>
